<template>
  <div>
    <div
      @click="onMisspellItemClicked"
      @keyup.enter="onMisspellItemClicked"
      class="panel__misspell"
      tabindex="0"
      name="'spellchecker-misspell-item'"
      v-aha-emit-action
    >
      <div class="flex gap-3">
        <SlideIndex :slideId="misspell.slideId" />
        <div>
          <SpellcheckerPhrase :words="misspell?.words" />
          <SpellcheckerCorrections
            v-if="misspell.isCorrectionsVisible"
            :misspell="misspell"
            :misspellIndex="misspellIndex"
            class="transition duration-200 ease-in-out"
          />
          <SpellcheckerAcceptDismissButtons
            v-if="misspell.isCorrectionsVisible"
            :misspell="misspell"
            class="transition duration-200 ease-in-out"
          />
        </div>
      </div>

      <!-- DISMISS BUTTON -->
      <aha-icon-button
        name="spellchecker-dismiss-button"
        size="sm"
        v-aha-emit-action
        v-tooltip="$i18nPresenter.t('Dismiss')"
        @click="onDismissButtonClicked"
        class="misspell-dismiss-button"
      >
        <aha-icon name="close-v2" />
      </aha-icon-button>
    </div>
    <div class="misspell-divider"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { scrollToActiveSlide } from '@/utils/dom.utils'
import utils from '@/util'
import EventBus from '@/eventBus'
import SpellcheckerPhrase from '@/components-v2/presentation-editor/editor-header/quality-control/SpellcheckerPhrase.vue'
import SlideIndex from '@/components-v2/presentation-editor/editor-header/quality-control/SlideIndex.vue'
import SpellcheckerCorrections from '@/components-v2/presentation-editor/editor-header/quality-control/SpellcheckerCorrections.vue'
import SpellcheckerAcceptDismissButtons from '@/components-v2/presentation-editor/editor-header/quality-control/SpellcheckerAcceptDismissButtons.vue'

export default {
  components: {
    SpellcheckerPhrase,
    SlideIndex,
    SpellcheckerCorrections,
    SpellcheckerAcceptDismissButtons,
  },

  props: {
    misspell: {
      type: Object,
      default: () => {},
    },
    misspellIndex: {
      type: Number,
      default: null,
    },
  },

  computed: {
    ...mapGetters(['getSlideById', 'presentationId']),
  },

  methods: {
    ...mapActions(['setSlideActiveAction']),
    ...mapActions('spellchecker', ['showCorrectionsAction', 'dismissMisspellAction']),

    async onMisspellItemClicked() {
      const { slideId } = this.misspell
      // const { slideId, misspelledWord, id } = this.misspell
      // this.showCorrectionsAction({ misspelledWord, id })

      const slideToActive = this.getSlideById({ slideId })
      this.setSlideActiveAction(slideToActive)
      EventBus.$emit('eventHandleSetValueTransition')
      await utils.sleep(200)
      scrollToActiveSlide()
    },

    onDismissButtonClicked() {
      this.dismissMisspellAction({
        presentationId: this.presentationId,
        misspell: this.misspell,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.panel__misspell {
  // @apply flex items-start gap-3 py-3 px-4 cursor-pointer border border-transparent;
  @apply flex items-start justify-between py-3 px-4 cursor-pointer border border-transparent;

  &:hover:not(:disabled) {
    @apply bg-base-10;
    .misspell-dismiss-button {
      @apply opacity-100;
    }
  }
  &:focus:not(:disabled), &:focus-visible:not(:disabled) {
    // @apply bg-base-0 border border-primary-80 outline-none;
    @apply bg-base-0 border-primary-80 outline-none;
  }
  &:active:not(:disabled) {
    @apply bg-base-30;
  }
  .misspell-dismiss-button {
    @apply opacity-0;
  }
}

.misspell-divider {
  content: "";
  width: calc(100% - 2rem);
  @apply h-0.25 bg-base-30 my-0 mx-auto;
}
</style>
